var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/empty.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_setup.emptyText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }